import { render, staticRenderFns } from "./DevToolAfas.vue?vue&type=template&id=2df8ea6e"
import script from "./DevToolAfas.vue?vue&type=script&lang=ts"
export * from "./DevToolAfas.vue?vue&type=script&lang=ts"
import style0 from "./DevToolAfas.vue?vue&type=style&index=0&id=2df8ea6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports